import { render, staticRenderFns } from "./RowRecibosAdmin.vue?vue&type=template&id=477e3625"
import script from "./RowRecibosAdmin.vue?vue&type=script&lang=js"
export * from "./RowRecibosAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports